import TransportationTicketDetail from './TransportationTicketDetail';

export default TransportationTicketDetail;
